export default {
  meta: {
    title: 'KA场地管理'
  }
};

